import React from 'react';
import confirmEmailSvg from 'assets/images/illustrations/undraw_confirm_rds7.svg';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import IntlMessages from 'util/IntlMessages';
import styles from './styles.module.less';
import { userSignOut } from 'appRedux/actions/Auth';
import Card from '../Auth/components/Card';

const ConfirmEmail = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onBackToLogin = () => {
    dispatch(userSignOut());
    history.push('/');
  };
  return (
    <Card className={styles.card}>
      <div className="gx-flex-column gx-align-items-center">
        <img width={400} height={400} src={confirmEmailSvg} />
        <div className="gx-mt-4 gx-fs-lg">
          <h2 className="gx-font-weight-bold gx-text-center gx-mb-4 gx-text-blue-primary">
            <IntlMessages id="app.userAuth.confirmEmail.title" />
          </h2>
          <p className="gx-font-weight-bold gx-text-black">
            <IntlMessages id="app.userAuth.confirmEmail.description" />
          </p>
        </div>
        <div className="gx-mt-4">
          <Button type="primary" block onClick={onBackToLogin}>
            <IntlMessages id="app.userAuth.confirmEmail.backToLogin" />
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default ConfirmEmail;
